import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { pickBy } from "lodash";
import { map, Observable } from "rxjs";
import { Domain } from "src/app/backend/models/organization/organization";
import { UserNotify } from "src/app/support/notify-decorator";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";

@Injectable()
export class DomainBackend {
  private readonly http = inject(HttpClient);

  @UserNotify({
    successMessage: marker("Dominio creato"),
    errorMessage: marker("Impossibile creare il dominio")
  })
  create(domain: { name: string; slug: string }): Observable<Domain> {
    return this.http.post<Domain>(
      `${environment.snoots.api.organization}/domains`,
      domain
    );
  }

  load(id: string): Observable<Domain> {
    return this.http.get<Domain>(
      `${environment.snoots.api.organization}/domains/${id}`
    );
  }

  loadBySlug(slug: string): Observable<Domain> {
    return this.http
      .get<PaginatedResult<Domain>>(
        `${environment.snoots.api.organization}/domains`,
        {
          params: {
            slug
          }
        }
      )
      .pipe(map((response: PaginatedResult<Domain>) => response.docs[0]));
  }

  publicLoadBySlug(slug: string): Observable<Domain> {
    return this.http
      .get<PaginatedResult<Domain>>(
        `${environment.snoots.api.organization}/public/domains`,
        {
          params: {
            slug
          }
        }
      )
      .pipe(map((response: PaginatedResult<Domain>) => response.docs[0]));
  }

  search(request: PageRequest): Observable<PaginatedResult<Domain>> {
    return this.http.get<PaginatedResult<Domain>>(
      `${environment.snoots.api.organization}/domains`,
      {
        params: pickBy({
          p: request.page,
          s: request.pageSize,
          ...request.filterValues
        })
      }
    );
  }

  @UserNotify({
    successMessage: marker("Dominio aggiornato"),
    errorMessage: marker("Impossibile aggiornare il dominio")
  })
  update(id: string, payload: Partial<Domain>): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.organization}/domains/${id}`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Dominio rimosso"),
    errorMessage: marker("Impossibile rimuovere il dominio")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.organization}/domains/${id}`
    );
  }

  @UserNotify({
    successMessage: marker("Dominio abilitato"),
    errorMessage: marker("Impossibile abilitare il dominio")
  })
  enable(id: string): Observable<void> {
    return this.http.put<void>(
      `${environment.snoots.api.organization}/domains/${id}/enable`,
      {}
    );
  }

  @UserNotify({
    successMessage: marker("Dominio disabilitato"),
    errorMessage: marker("Impossibile disabilitare il dominio")
  })
  disable(id: string): Observable<void> {
    return this.http.put<void>(
      `${environment.snoots.api.organization}/domains/${id}/disable`,
      {}
    );
  }
}
